export const BASE_URL = "https://opentalk-uuut.onrender.com/"
